module.exports = __webpack_public_path__ + "img/rareum_galaxytoken1.867306a.png";